var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_180",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_180",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEA0lEQVR4nO2aT2gUdxTHp0Wxrbb0rwdR2hzaQA+9CIW2AelBFBE1ye/tav+QS+uhID2It4KHHqJUBD0pHoT82fd2EG1zyKUpIaXagmI2+16SIpS2WEulmmou/WPiljeZCbuzm92NMzsz0fnCj52d+c3v9z7zfvN77zczlpUqVapUqVKlSrSyyJsMyjlAngWSUqIK8qxBvgD2RHtosIB8O3awBsWQzKitgYGNejYBQM0VtgMDQxKH8ZJe5rvBgSl+kOWUFHi5ittjK9TD/AsgDxjiI4bkIOSlR4tu6z495tRZ4cCXIS8fg11oa7ovu9BmiD9yzl0pwAZlCGzpCNyvLR1OW0kFNiQzgPyhFbK6kXcC8e8JA+ZvO/sK660WSds2yGOJADbIY7u+nH7aarF2Dl15CohHYgU2KN+pIVZEWoCWi7EAG5KZzv6JjVbE0j6d+SIG4ANWTNK+IwU2JH/0nP35CSsm7T99ZTWQXI/Qw9zrr7fn/NQLVqn0mH//4cOlx51jrvRC7Rv88cXyOroPbFnn/X9vsPgc2MXNXtmbm95QbRf3RgdsVyYWWZx+BVDmDPFnVecjHwPkf8C++pL+N8g5faDQNTD5cpnxw4A87nnPEP9Z0R/KnB86Q/xOJMCGeP6DvsLaijp28a0Fw/hUNbCge5Fed+G+8Wb4LaOjqxYughSA5KZua4hzIX9byL2dXPuQjpTydtUGtSUCYJmpqvMAwC7U50sB6wVpZFut2Tp0YEC+HRRYPWOQv9ffDPG7NYGJ/waSn5yCcun9/mvP1LDtZkT38KUngwLryghQ7hjiG+7ScGlgkot+YPdeb/2QBsf4ykeiDwLsbOeLmbJ2lzWkuwYnX40yDh9YAnh8caLJS08jYPf4mVrAjSYtQP40OmCsvPpeWPInJxqXDckX5WEJSPoA+VffokAApVgnLN3zhyW1Ibo4jHwfbHmzvJ4aVJ4saPKg+9UzYMvzXj0F8t+PGmJ2Xxh/ttnEA3LFrTGslviHWplVq6Wx253VowYWHbYHrYhliI/Xs6nFwDwPOTGhkDRjS1721bOn5cDgxUvkrNViZWhyByD/GzsweJMYylEvNw5bkJNdbiLS0JZogGlxIpMM8TYrRBniT/whL0HA4oGPGOK9QR4SaPpalpSUEg4s7lCXv4B4ULOibuS3tw9fW9NMn1mceq1e6EkuMFXd67ONnoXpBBjknXSygMkpl2v1o4+BDEp/0PYTB2yQv67p1Rpr24cDmORE5RKPvwqz/cQBA/Kp7lzxDUA+aUj+C7v9R+qjFkC5ExjY6EdfcYM0WQxyPriH7Yn2eu9yElOQb4X2riurX+MR2/odVOK8SnxXPRvHi71UqVKlSpUqlbUs/Q88tcUhKFhEqAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/LINE.e27e975825408cc48c95413eb9339d5e.svg";
export { ForwardRef as ReactComponent };